import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=e706576a&scoped=true&"
import script from "./BaseTab.vue?vue&type=script&lang=ts&"
export * from "./BaseTab.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=e706576a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706576a",
  null
  
)

export default component.exports